// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__o56sT","arrowRight":"styles_arrowRight__rAug5"};